import { configureStore } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
import { rootReducer } from "./applicationState";

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          "aree/setData",
          "sponsor/setData",
          "faq/setData",
          "highlight/setData",
          "food/setData",
          "tournament/setData",
          "programma/setData",
        ],
      },
    }),
});

export type AppThunkDispatch = typeof store.dispatch;

export const useAppDisoatch = (): AppThunkDispatch =>
  useDispatch<AppThunkDispatch>();

export type RootState = ReturnType<typeof store.getState>;
